import { useSelected } from '../../../core';
import {
  MacroPlaceholderRenderMode,
  type MacroPlaceholderPluginElement,
  type MacroPlaceholderPluginPropertyOptions,
} from '../types';
import type { GetRenderElementComponentType } from '../../../utils/getRenderElement';
import { unreachableCaseError } from 'types';
import { useReporterState } from '../../../hooks';
import styled from 'styled-components';
import { MacroPlaceholderTemplateElement } from './MacroPlaceholderTemplate';
import { MacroPlaceholderChipElement } from './MacroPlaceholderChipElement';

export const MacroPlaceholderEditable: GetRenderElementComponentType<
  MacroPlaceholderPluginPropertyOptions,
  MacroPlaceholderPluginElement
> = ({ pluginOptions, element, ...rest }): React.ReactElement => {
  const { variant } = useReporterState();
  const selected = useSelected();
  const isMacroPlaceholderChipEnabled =
    pluginOptions.renderMode === MacroPlaceholderRenderMode.ChipElement;

  switch (variant) {
    case 'report':
      throw new Error('Macros cannot be a part of report content.');
    case 'fragment':
    case 'template':
      if (isMacroPlaceholderChipEnabled) {
        return (
          <MacroPlaceholderChipElement {...rest} selected={selected} element={element} size="xs" />
        );
      }

      return <MacroPlaceholderTemplateElement {...rest} selected={selected} element={element} />;

    default:
      return unreachableCaseError(variant);
  }
};

export const MacroPlaceholderRenderer = styled(MacroPlaceholderTemplateElement)`
  white-space: pre-wrap;
`;
